// extracted by mini-css-extract-plugin
export default {"paginationPagesButton":"Pagination_paginationPagesButton__DTElL","oneStepButton":"Pagination_oneStepButton__Jlncl","treeDotsForward":"Pagination_treeDotsForward__Unr0P"};